var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.167a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm2.779 5.605a4.167 4.167 0 10-5.557 0 6.668 6.668 0 00-3.889 6.061.833.833 0 101.667 0 5 5 0 0110 0 .833.833 0 101.667 0 6.668 6.668 0 00-3.888-6.061z",
    fill: "#515158"
  })));
}

export default SvgPerson;